import { http } from 'utils'

import { ReportVoucherRedemptionCountCreateFormTypes, ReportVoucherRedemptionCountAPISchemas} from "schemas/reports-voucher-count-schemas"

export const  postReportVoucherRedemptionCountService = async(payload: ReportVoucherRedemptionCountCreateFormTypes) => {

    const url = `/vouchers/redemption/counts`
    const response = await http.post(url, payload)
    const result = ReportVoucherRedemptionCountAPISchemas.safeParse(response.data)
    if (!result.success) 
      throw result.error
    return result.data
}
